import React, { useContext, useState } from 'react';
import { Project, StateContext } from '../../StateContext';
import {
    Modal,
    Button,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material';
import { boxStyle } from './styles';
import { connectMechanicCall } from '../../Services/APICalls/apicalls';
import { IContextData } from '../../../App';
import { useLanguage } from '../../Services/LanguageContext';

interface PProps {
    id: number;
}

const ConnectMechanic = (props: PProps) => {
    const [open, setOpen] = useState(false);
    const { t } = useLanguage();

    const { loginData, setLoginData } = useContext<IContextData>(StateContext);

    const [mechanicId, setMechanicId] = useState(loginData.mechanics[0].id);
    const [projectTypeId, setProjectTypeId] = useState<number | ''>('');
    const [error, setError] = useState<string | null>(null);

    const project = loginData.projects.find((p) => p.id === props.id);
    const projectTypes = project?.types ?? [];

    const connectMechanicHandler = () => {
        if (projectTypes.length > 0 && projectTypeId === '') {
            setError(t('typeRequiredForConnect'));
            return;
        }

        const selectedTypeId = projectTypeId === '' ? null : projectTypeId;
        const existingLink = project?.links?.find(
            l => l.mechanicId === mechanicId && l.projectTypeId === selectedTypeId
        );
        if (existingLink) {
            const existingType = projectTypes.find(pt => pt.id === existingLink.projectTypeId);
            setError(existingType
                ? `${t('mechanicAlreadyConnectedToType')} "${existingType.name}".`
                : t('mechanicAlreadyConnected')
            );
            return;
        }

        connectMechanicCall(props.id, mechanicId, setLoginData, t, projectTypeId === '' ? null : projectTypeId);
        setOpen(false);
    };

    const handleMechanicChange = (x) => {
        setMechanicId(parseInt(x.target.value));
        setError(null);
    };

    return (
        <React.Fragment>
            <Button
                variant='outlined'
                color='success'
                onClick={() => { setOpen(true); setError(null); }}
            >
                {t('connectMechanic')}
            </Button>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Box style={boxStyle}>
                    <form action='#' style={{ width: '100%' }}>
                        <div className='flex flex-col justify-between items-stretch gap-3'>
                            {error && (
                                <div style={{
                                    color: '#f87171',
                                    fontSize: '13px',
                                    padding: '8px 12px',
                                    background: 'rgba(239,68,68,0.1)',
                                    borderRadius: '6px',
                                    border: '1px solid rgba(239,68,68,0.3)',
                                }}>
                                    {error}
                                </div>
                            )}
                            <FormControl fullWidth>
                                <InputLabel id='mechanic-select-label'>
                                    {t('mechanic')}
                                </InputLabel>
                                <Select
                                    labelId='mechanic-select-label'
                                    id='mechanic-select'
                                    value={mechanicId}
                                    label={t('mechanic')}
                                    onChange={handleMechanicChange}
                                >
                                    {loginData.mechanics.map((mechanic) => (
                                        <MenuItem
                                            key={mechanic.id}
                                            value={mechanic.id}
                                        >
                                            {mechanic.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            {projectTypes.length > 0 && (
                                <FormControl fullWidth>
                                    <InputLabel id='project-type-select-label'>
                                        {t('workType')}
                                    </InputLabel>
                                    <Select
                                        label={t('workType')}
                                        labelId='project-type-select-label'
                                        id='project-type-select'
                                        value={projectTypeId}
                                        onChange={(x) => { setProjectTypeId(x.target.value as number | ''); setError(null); }}
                                    >
                                        <MenuItem value=''>{t('noType')}</MenuItem>
                                        {projectTypes.map((pt) => (
                                            <MenuItem key={pt.id} value={pt.id}>
                                                {pt.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )}
                            <button
                                style={{ width: '100%' }}
                                onClick={connectMechanicHandler}
                            >
                                {t('connect')}
                            </button>
                        </div>
                    </form>
                </Box>
            </Modal>
        </React.Fragment>
    );
};

export default ConnectMechanic;
